module.exports = __webpack_public_path__ + "static/media/2016-WSIS-ActionLineC7.ac776dd6.webp";